export { create, get } from "./basic/api";
export { supported } from "./basic/supported";
export { schema } from "./basic/schema";

export type {
  PublicKeyCredentialDescriptorJSON,
  PublicKeyCredentialWithAssertionJSON,
  PublicKeyCredentialWithAttestationJSON,
  CredentialCreationOptionsJSON,
  CredentialRequestOptionsJSON,
} from "./basic/json";
